<app-header [title]="'Pipeline'">
</app-header>

<form novalidate [formGroup]="projectModuleForm" #pipeline>
  <div class="form-group">
    <div class="bc flex-row">
      <div class="flex-row flex-align-start flex-auto flex-25"
        style="padding:0 10px 10px 30px">

        <div class="flex-row flex-100" style="border:none;padding-top:20px">

          <kendo-switch formControlName="IsComingled"
            [onLabel]="''"
            [offLabel]="''"></kendo-switch>
          <div style="padding:5px 0px 0px 20px">Comingled</div>
        </div>

        <div class="flex-row flex-100" style="border:none;padding-top:20px">

          <kendo-switch formControlName="IsPiggingLine"
            [onLabel]="''"
            [offLabel]="''"></kendo-switch>
          <div style="padding:5px 0px 0px 20px">Pigging Line</div>
        </div>
      </div>
      <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 30px">

        <div style="width:100%">
          <div class="dp-label">Pipe Material</div>
          <kendo-combobox class="cem-kd-combo form-control" formControlName="PipeMaterial"
            [data]="selectMaterial"
            [placeholder]="'Select Pipe Material...'"
            [clearButton]="false">
          </kendo-combobox>
        </div>

        <div style="width:100%">
          <div class="dp-label">Pipe Nominal Diameter (in)</div>
          <kendo-combobox class="cem-kd-combo form-control" formControlName="PipeNominalDiameter"
            [data]="selectDiameter"
            [placeholder]="'Select Diameter...'"
            [clearButton]="false">
          </kendo-combobox>
        </div>

        <div style="width:100%">
          <div class="dp-label">Pressure Rating (psi)</div>
          <kendo-combobox class="cem-kd-combo form-control" formControlName="PressureRating"
            [data]="selectRating"
            [placeholder]="'Select Rating...'"
            [clearButton]="false">
          </kendo-combobox>
        </div>

      </div>
      <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 30px">

        <div style="width:100%">
          <div class="dp-label">GIS Estimated Pipeline Length</div>
          <kendo-numerictextbox formControlName="GisEstimatedPipeLength" class="form-control"
            [min]="2000"
            [max]="20000"
            [step]="10"
            [value]="3000"
            [decimals]="decimalPrecision"
            [spinners]="false"
            [format]="decimalFormat">
          </kendo-numerictextbox>
        </div>

        <div style="width:100%">
          <div class="dp-label">Pipeline Length (ft)</div>
          <kendo-numerictextbox formControlName="PipelineLength" class="form-control"
            [min]="2000"
            [max]="20000"
            [step]="10"
            [value]="2500"
            [decimals]="decimalPrecision"
            [spinners]="false"
            [format]="decimalFormat">
          </kendo-numerictextbox>
        </div>

        <div style="width:100%">
          <div class="dp-label">Bore Length (ft)</div>
          <kendo-numerictextbox formControlName="BoreLength" class="form-control"
            [min]="100"
            [max]="20000"
            [step]="10"
            [value]="200"
            [decimals]="decimalPrecision"
            [spinners]="false"
            [format]="decimalFormat">
          </kendo-numerictextbox>
        </div>

      </div>
      <div class="flex-row flex-align-start flex-auto flex-25" style="padding:0 10px 10px 30px">

        <div style="width:100%">
          <div class="dp-label">Line Crossings</div>
          <kendo-numerictextbox formControlName="LineCrossings" class="form-control"
            [min]="0"
            [max]="20"
            [step]="1"
            [value]="1"
            [decimals]="decimalPrecision"
            [spinners]="false"
            [format]="decimalFormat">
          </kendo-numerictextbox>
        </div>

        <div style="width:100%">
          <div class="dp-label">Percent Rock</div>
          <kendo-numerictextbox formControlName="RockPercent" class="form-control"
            [min]="0"
            [max]=".2"
            [step]=".01"
            [value]=".05"
            [format]="percentFormat"
            [spinners]="false">
          </kendo-numerictextbox>
        </div>
        <div style="padding-top:10px">
          @if (isFormNew && !isProjectModuleReadError && projectModuleForm.valid ) {
          <button type="button" kendoButton
            color="primary" (click)="createProjectModule($event)">
            Create
          </button>
          }
          @if (!isFormNew && !isProjectModuleReadError && projectModuleForm.dirty) {
          <button type="button" kendoButton
            color="primary" (click)="updateProjectModule($event)">
            Update
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</form>